import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import { ManutencaoGrupoComponent } from './manutencao-grupo/manutencao-grupo.component';
import { ManutencaoUsuarioComponent } from './manutencao-usuario/manutencao-usuario.component';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { ToolbarModule } from 'primeng/toolbar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule, DatePipe } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CardModule } from 'primeng/card';
import { InputMaskModule } from 'primeng/inputmask';
import {PhonePipe} from './shared/phone-pipe/phone.pipe';
import { StatusBadgePipe } from './shared/status-badge-pipe/status-badge.pipe';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { InterceptorModule } from './core/intercepor/auth.interceptor.module';
import { ManutencaoProcessamentoComponent } from './manutencao-processamento/manutencao-processamento.component';
import { ProcessamentoListaComponent } from './processamento-lista/processamento-lista.component';
import { ProcessamentoDocumentosComponent } from './processamento-documentos/processamento-documentos.component';
import { AjudaComponent } from './ajuda/ajuda.component';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChartModule } from 'primeng/chart';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    AppComponent,
    ManutencaoProcessamentoComponent,
    ProcessamentoListaComponent,
    ProcessamentoDocumentosComponent,
    ManutencaoGrupoComponent,
    ManutencaoUsuarioComponent,
    AjudaComponent,
    DashboardComponent,
    MenuBarComponent,
    PhonePipe,
    StatusBadgePipe
  ],
  imports: [
    InterceptorModule,
    LoginModule,
    PanelModule,
    TabViewModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PasswordModule,
    InputTextModule,
    ButtonModule,
    MenubarModule,
    TableModule,
    ToolbarModule,
    OverlayPanelModule,
    MessagesModule,
    ToastModule,
    ConfirmPopupModule,
    DialogModule,
    HttpClientModule,
    FormsModule,
    CalendarModule,
    CommonModule,
    DropdownModule,
    PaginatorModule,
    TriStateCheckboxModule,
    ConfirmDialogModule,
    CardModule,
    InputMaskModule,
    InputTextareaModule,
    FileUploadModule,
    ChartModule,
    TooltipModule
  ],
  providers: [
    DatePipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
